import { Box, Divider, useTheme } from "@material-ui/core";

const HeaderPillow = ({ whiteLabelPartner = {} }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(2),
        overflow: 'hidden',
        height: '60px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        width: '100%',
      }}
    >
      <img
        src="/assets/images/zennya.svg"
        alt="Zennya Health"
        style={{
          maxHeight: '100%',
          maxWidth: '50%', // Limit width to half of the container's width
          objectFit: 'contain',
          height: 'auto',
        }}
      />
      {whiteLabelPartner && whiteLabelPartner.logo_url && (
        <>
          <Divider
            orientation="vertical"
            style={{ height: '100%', width: 1 }}
          />
          <img
            src={whiteLabelPartner?.logo_url}
            // src="/assets/images/genericlogo.png"
            alt={whiteLabelPartner?.label}
            style={{
              maxHeight: '100%',
              maxWidth: '50%', // Limit width to half of the container's width
              objectFit: 'contain',
              height: 'auto',
            }}
          />
        </>
      )}
    </Box>
  );
};

export { HeaderPillow };

